import { connect } from 'react-redux';
import { compose, branch, renderComponent, renderNothing } from 'recompose';
import { find, get, isEmpty } from 'lodash';

import { currentAppointmentHavePermissions } from 'modules/appointmentInfo/selectors/currentAppointment';
import { PERMITTED_PERMISSIONS, NO_RESTRICTION } from '../constants/permisssionsTypes';

const makeMapStateToProps = conditions => {
  const permissionCheckerSelector = currentAppointmentHavePermissions(conditions);

  return (state) => ({
    havePermission: permissionCheckerSelector(state),
  });
};

export const renderByCurrentAppointmentPermission = conditions => (Component, AlternativeComponent) => compose(
  connect(makeMapStateToProps(conditions)),
  branch(
    ({ havePermission }) => havePermission,
    renderComponent(Component),
    AlternativeComponent ? renderComponent(AlternativeComponent) : renderNothing,
  ),
)();

export const renderByPermission = conditions => (Component, AlternativeComponent) => compose(
  connect((state) => ({
    permissions: get(state, 'session.sessionInfo.permissions', []),
  })),

  branch(
    ({ permissions, renderConditions }) => {
      const conditionsToTest = renderConditions || conditions;

      return !isEmpty(conditionsToTest) && permissions.length && conditionsToTest.every(item => {
        const [resourceCode, property] = item.split('.');
        return permissions.some(({ roleResources }) => {
          const resource = find(roleResources, { resourceCode });
          const propertyVal = get(resource, property);
          return PERMITTED_PERMISSIONS.includes(propertyVal);
        });
      });
    },
    renderComponent(Component),
    AlternativeComponent ? renderComponent(AlternativeComponent) : renderNothing,
  ),
)();

const mapStateToProps = (state) => {
  const { permissionsMatrix: userPermissionsMatrix } = state.authorization.userInfo;
  return {
    userPermissionsMatrix,
  };
};

const checkAnyUnitHavePermissions = ({ userPermissionsMatrix, conditions }) => {
  if (conditions === NO_RESTRICTION) return true;

  return !isEmpty(conditions) && userPermissionsMatrix && Object.values(userPermissionsMatrix).some(
    permissionByUnit => conditions.every(item => get(permissionByUnit, item)),
  );
};

const ProtectedComponent = ({ children: WrappedComponent }) => WrappedComponent;

export const RenderByPermission = compose(
  connect(mapStateToProps),
  branch(
    ({ userPermissionsMatrix, renderConditions }) => {
      return !checkAnyUnitHavePermissions({ userPermissionsMatrix, conditions: renderConditions });
    },
    renderNothing,
  ),
)(ProtectedComponent);
